export const DashboardTypes = {
  RETRIEVE_ALL_DASHBOARD_REQUEST: '[dashboard]RETRIEVE_ALL_DASHBOARD_REQUEST',
  RETRIEVE_ALL_DASHBOARD_SUCCESS: '[dashboard]RETRIEVE_ALL_DASHBOARD_SUCCESS',
  RETRIEVE_ALL_DASHBOARD_FAILURE: '[dashboard]RETRIEVE_ALL_DASHBOARD_FAILURE',
};
